/* global $:true */
import debug from "debug";
import plugin from "@core/lib/plugin";
import cartCheck from "../cart-check/cart-check";
import loadingGlobal from "../../lib/loading-global";
import { GAServices } from "../../services/ga-services";

var PLUGIN_NAME = "windcaveIframeContainer";
var ELEMENT_SELECTOR = "[data-windcave-iframe-container]";
var Promise = require("es6-promise").Promise;
const log = debug(PLUGIN_NAME);
var windcaveApi;

// Allowing space for two tall validation errors at 320px viewport
const IFRAME_HEIGHT_NEW_CARD = 580;

// CVC input only
const IFRAME_HEIGHT_SAVED_CARD = 380;

// NOTE: Need to be running under https to see this working

class WindcaveIframeContainer {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);

		if (!this.options.url) {
			log(
				`Missing url. data-windcave-iframe-container-url="..." Aborting`
			);
			return false;
		}
		this.url = this.options.url;

		if (!this.options.processPaymentUrl) {
			log(
				`Missing process payment url. data-windcave-iframe-container-process-payment-url="..." Aborting`
			);
			return false;
		}

		if (!this.options.errorElementSelector) {
			log(
				`Error element selector not provided. data-windcave-iframe-container-error-element-selector="..." Aborting`
			);
			return false;
		}

		this.$errorElement = $(this.options.errorElementSelector);

		if (!this.$errorElement[0]) {
			log(
				`Element matching error element selector not found. data-windcave-iframe-container-error-element-selector="${this.options.errorElementSelector}" Aborting`
			);
			return false;
		}

		if (!this.options.sessionId) {
			log(
				`Session id not provided. data-windcave-iframe-container-session-id="..." Aborting`
			);
			return false;
		}
		this.sessionId = this.options.sessionId;

		this.loadingElement = document.querySelector(
			this.options.loadingSelector
		);

		if (!this.options.sessionId) {
			log(
				`Saved or new card option not provided. data-windcave-iframe-container-saved-or-new-card="..." Aborting`
			);
			return false;
		}
		this.savedOrNewCard = this.options.savedOrNewCard;

		this.$submitButton = $("#" + this.options.submitButtonId);
		if (!this.$submitButton[0]) {
			log(
				`Element matching submit button id not found ("${this.options.submitButtonId}"). data-windcave-iframe-container-submit-button-id="..." Aborting`
			);
			return false;
		}

		this.paymentFormComponent = document.querySelector(this.options.paymentFormComponentSelector);

		if(this.paymentFormComponent){
			this.cartCheckEndpoint = this.paymentFormComponent.dataset["paymentFormCartCheckEndpoint"];
			this.cartCheckRedirectPath = this.paymentFormComponent.dataset["paymentFormCartCheckRedirectPath"];
		}

		log("construct", element, options);
		this.init();
	}

	init() {
		log("init");
		var mod = this;
		this.initWindcaveApi()
			.then(() => {
				log("Windcave JS loaded");
				mod.initWindcaveSeamlessPayments();
				mod.updateWindcaveSubmitPurpose();
			})
			.catch((reason) => {
				log("Windcave JS js not loaded", reason);

				// Or maybe it is loaded??
				if (typeof window.WindcavePayments !== "undefined") {
					log("Windcave API promise timeout. Setting from window.");
					mod.windcaveApi = window.WindcavePayments;
					mod.initWindcaveSeamlessPayments();
					mod.updateWindcaveSubmitPurpose();
				} else {
					mod.errorMessage = "Unable to load windcave API";
					mod.showError();
				}
			});

		this.watch();
	}

	watch() {
		document.addEventListener(
			"update-windcave-url",
			this.onUrlUpdate.bind(this)
		);
	}

	onUrlUpdate(event) {
		const url = event.detail["url"];
		const savedOrNewCard = event.detail["savedOrNewCard"];
		const sessionId = event.detail["sessionId"];

		if (!sessionId) {
			return false;
		}

		this.updateWindcaveUrl(url, savedOrNewCard, sessionId);
	}

	loadWindcaveAPI() {
		var windowRef = window ? window : {};
		var script = document.createElement("script");

		script.type = "text/javascript";

		script.src =
			"https://sec.windcave.com/js/windcavepayments-seamless-v1.js";
		script.onload = function () {
			windowRef.windcaveApiLoaded();
		};
		document.querySelector("head").appendChild(script);
	}

	initWindcaveApi() {
		if (this.windcaveApi) {
			return Promise.resolve(windcaveApi);
		}

		var mod = this;
		var windowRef = window ? window : {};

		loadingGlobal.show();

		var deferred = function (resolve, reject) {
			windowRef.windcaveApiLoaded = function () {
				if (windowRef.WindcavePayments) {
					mod.windcaveApi = windowRef.WindcavePayments;
					loadingGlobal.hide();
					resolve();
				}
			};

			mod.loadWindcaveAPI();

			setTimeout(function () {
				if (!windowRef.windcaveApi) {
					reject(new Error("Loading took too long"));
				}
			}, 5000);
		};

		return new Promise(deferred);
	}

	initWindcaveSeamlessPayments() {
		if (this.windcaveApi) {
			var heightNewCard = IFRAME_HEIGHT_NEW_CARD;
			var heightSavedCard = IFRAME_HEIGHT_SAVED_CARD;
			var height =
				this.savedOrNewCard == "saved"
					? heightSavedCard
					: heightNewCard;
			this.$errorElement.hide();
			var mod = this;
			this.element.hidden = true;
			loadingGlobal.show();

			this.windcaveApi.Seamless.prepareIframe({
				url: this.url,
				containerId: this.options.containerId,
				enableValidationOnFieldExit: true,
				loadTimeout: 30,
				width: 400,
				height: height,
				threeDS: {
					// this is an iframe within the parent iframe that contains styles that presume it is at least as tall as the parent iframe
					width: 400,
					height: 580,
				},
				onProcessed: function (result) {
					log("processed", result);
					mod.hideLoading();
					loadingGlobal.hide();

					const eventName = {
						"done": "windcave_prepare_iframe_done",
						"3DSecure": "windcave_prepare_iframe_3dsecure",
						"loaded": "windcave_prepare_iframe_loaded"
					};

					hj("event", eventName[result] || "windcave_prepare_iframe_unknown");
				},
				onError: function (error) {
					log("error", error);
					mod.errorMessage =
						"Error loading windcave iframe: " + error;
					mod.showError();
					mod.hideLoading();
					loadingGlobal.hide();

					const eventName = {
						"timeout": "windcave_prepare_iframe_error_timeout",
						"browser-not-supported": "windcave_prepare_iframe_error_unsupported",
						"action-in-process": "windcave_prepare_iframe_error_action_in_process",
						"no-container": "windcave_prepare_iframe_error_no_container",
						"invalid-url": "windcave_prepare_iframe_error_invalid_url",
						"session-error": "windcave_prepare_iframe_error_session",
						"finished": "windcave_prepare_iframe_error_finished"
					};

					hj("event", eventName[error] || "windcave_prepare_iframe_error_unknown");
				},
			});
		}
	}

	updateWindcaveUrl(url, savedOrNewCard, sessionId) {
		this.url = url;
		this.savedOrNewCard = savedOrNewCard;
		this.sessionId = sessionId;
		this.initWindcaveSeamlessPayments();
	}

	forceRefund() {
		document.dispatchEvent(new CustomEvent('forceRefund'));
	}

	showLoading() {
		this.loadingElement.hidden = false;
		this.element.hidden = true;
	}

	hideLoading() {
		this.loadingElement.hidden = true;
		this.element.hidden = false;
	}

	disablePaymentSubmit() {
		this.$submitButton.attr("disabled", "");
		this.$submitButton.addClass("is-submitting");
	}

	enablePaymentSubmit() {
		this.$submitButton.removeAttr("disabled");
		this.$submitButton.removeClass("is-submitting");
	}

	processPayment() {
		this.requestKey = "" + Date.now();
		var mod = this;
		const endpoint = `${this.options.processPaymentUrl}&requestKey=${this.requestKey}&sessionId=${this.sessionId}`;

		mod.showLoading();
		hj("event", "process_payment");

		fetch(endpoint)
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			})
			.then((data) => {
				log("data", data);
				// Ignore all but the most recent request
				if (data.RequestKey === this.requestKey) {
					if (data.Success) {
						hj("event", "process_payment_success");
						window.location = data.RedirectUrl;
					} else {
						hj("event", "process_payment_fail");
						mod.errorMessage = data.ErrorMessage;
						mod.sessionId = data.SessionId;
						mod.url = data.FormPostUrl;

						mod.initWindcaveSeamlessPayments();
						mod.enablePaymentSubmit();
						mod.showError();
					}
				}
			})
			.catch((error) => {
				log("error", error);
				mod.errorMessage = "Error processing payment: " + error;
				hj("event", "process_payment_error");
				mod.enablePaymentSubmit();
				mod.showError();
			});
	}

	showError() {
		this.$errorElement
			.find(this.options.errorMessageSelector)
			.text(this.errorMessage);
		this.$errorElement.removeAttr("hidden").show();
	}

	validateForm() {
		if (this.windcaveApi) {
			var mod = this;
			this.$errorElement.hide();
			this.windcaveApi.Seamless.validate({
				onProcessed: function (result) {
					if (result) {
						hj("event", "windcave_validate_valid");
						mod.windcaveApi.Seamless.submit({
							showSpinner: true,
							onProcessed: function (result) {
								GAServices.sendPaymentInfo();
								hj("event", "windcave_submit_success");
								log("Processed and valid", result);
								if (result == "done") {
									hj("event", "windcave_submit_done");
									mod.disablePaymentSubmit();
									mod.processPayment();
								} else if (result == "3DSecure") {
									hj("event", "windcave_submit_3dsecure");
								}
							},
							onError: function (error) {
								log(error);
								mod.forceRefund();
								mod.errorMessage =
									"Error submitting payment: " + error;
								mod.enablePaymentSubmit();
								mod.showError();
								hj("event", "windcave_submit_error");
							},
						});
					} else {
						hj("event", "windcave_validate_invalid");
					}
				},
				onError: function (error) {
					log("Error and invalid", error);
					mod.errorMessage = "Validation error: " + error;
					mod.enablePaymentSubmit();
					mod.showError();
					mod.forceRefund();

					const eventName = {
						"not-ready": "windcave_validate_error_not_ready",
						"action-in-process": "windcave_validate_error_action_in_process",
						"exception": "windcave_validate_error_exception"
					};

					hj("event", eventName[error] || "windcave_validate_error_unknown");
				},
			});
		}
	}

	updateWindcaveSubmitPurpose() {
		this.$submitButton[0].addEventListener("click", this.submitButtonHandler.bind(this));
	}

	submitButtonHandler() {
		if (!this.cartCheckEndpoint) {
			this.validateForm();
		} else {
			cartCheck(this.cartCheckEndpoint).then((count)=>{
				if(!count) {
					log("Empty cart!");
					hj("event", "submit_cart_check_empty");
					this.redirectToCart();
				} else {
					this.validateForm();
				}
			}).catch((error)=>{
				log("Cart check failed!", error);
				hj("event", "submit_cart_check_fail");
				this.redirectToCart();
			});
		}
	}

	redirectToCart() {
		if(this.cartCheckRedirectPath) {
			window.location.pathname = this.cartCheckRedirectPath;
		}
	}
}

WindcaveIframeContainer.DEFAULTS = {
	containerId: "windcaveIframe",
	submitButtonId: "cc-checkout",
	errorMessageSelector: ".notification__message",
};

plugin(PLUGIN_NAME, WindcaveIframeContainer);

export function exec() {
	$(document).ready(() => {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/windcave-iframe-container/index.js